/**
 * Input Schema of RotaSla
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {RotaSla} from '@/model/resource/RotaSla'
import {PontaSlaCollection} from '@/model/collection/PontaSlaCollection'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'

/* TODO: review generated schema */
export class InputRotaSlaSchema extends Schema {
  collectionPontaSla = new PontaSlaCollection().noPagination()
  collectionResponsavel = new ResponsavelCollection().noPagination()

  readonly name = 'InputRotaSla'

  readonly fieldSet: FieldSet<RotaSla> = {
    pontaSla1: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionPontaSla.all(),
      },
    }),
    pontaSla2: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionPontaSla.all(),
      },
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionResponsavel.all(),
      },
    }),
    valor: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'currency',
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
  }
}
